import React, { useState, useEffect } from 'react';
import { getAccessToken } from '../../../utils/token-service';
import { AGENT_ASSIST_TRANSCRIPT_LINK } from '../../../utils/apiUrls';
import Markdown from 'markdown-to-jsx';

interface TranscriptModalProps {
	isOpen: boolean;
	onClose: () => void;
	transcriptLink?: string;
}

const TranscriptModal: React.FC<TranscriptModalProps> = ({ isOpen, onClose, transcriptLink }) => {
	const [transcriptContent, setTranscriptContent] = useState<string | null>(null);

	useEffect(() => {
		const fetchTranscriptContent = async () => {
			const accessToken = await getAccessToken();
			const requestOptions = {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${accessToken}`,
				},
			};

			try {
				if (transcriptLink) {
					const url = `${AGENT_ASSIST_TRANSCRIPT_LINK}?gcs_url=${transcriptLink}`;
					console.log('transcriptLinkurl', url);
					const response = await fetch(url, requestOptions);

					if (response.ok) {
						const jsonResponse = await response.json();
						const content = jsonResponse.content || 'No content available';
						const formattedContent = formatTranscript(content);
						setTranscriptContent(formattedContent);
					} else {
						setTranscriptContent('Error loading transcript.');
					}
				}
			} catch (error) {
				console.error('Error fetching transcript:', error);
				setTranscriptContent('Error fetching transcript.');
			}
		};

		if (isOpen && transcriptLink) {
			fetchTranscriptContent();
		}
	}, [isOpen, transcriptLink]);

	const formatTranscript = (text: string): string => {
		return text.replace(/\\n/g, '\n').replace(/\n+/g, '\n\n'); // Replace multiple \n with just one
	};

	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-500 bg-opacity-75">
			<div className="bg-white p-4 rounded-lg shadow-lg w-3/4 max-w-3xl overflow-hidden">
				<div className="flex justify-between items-center">
					<h3 className="text-xl font-semibold">Transcript</h3>
					<button onClick={onClose} className="text-gray-500 text-3xl hover:text-gray-800">
						&times;
					</button>
				</div>
				<hr className="my-2 border-gray-300" /> {/* Horizontal line added here */}
				<div className="mt-4 max-h-96 overflow-y-auto">
					{/* Use Markdown to render the formatted content */}
					<Markdown className="whitespace-pre-wrap text-sm text-gray-700">
						{transcriptContent || 'Loading transcript...'}
					</Markdown>
				</div>
			</div>
		</div>
	);
};

export default TranscriptModal;
